// Color Swatch Navigation - Size Selection Preservation Only
// Minimal, fast implementation - accepts color reordering

(function() {
  'use strict';

  // Get currently selected size
  function getCurrentSize() {
    const sizeInput = document.querySelector('input[name*="Size"]:checked');
    return sizeInput ? sizeInput.value : null;
  }

  // Preserve size when clicking color swatches
  function attachColorSwatchListeners() {
    const colorSwatches = document.querySelectorAll('.color-swatch:not(.color-swatch--active)');

    if (!colorSwatches || colorSwatches.length === 0) {
      // No color swatches found, nothing to do
      return;
    }

    colorSwatches.forEach(swatch => {
      if (!swatch || !swatch.href) return;

      swatch.addEventListener('click', function(e) {
        try {
          const currentSize = getCurrentSize();

          if (currentSize) {
            e.preventDefault();
            const url = new URL(this.href, window.location.origin);
            url.searchParams.set('size', currentSize);
            window.location.href = url.toString();
          }
        } catch (error) {
          // Let the click proceed normally if our code fails
          if (Shopify.designMode || window.DEBUG) {
            console.error('[Color Swatch] Error preserving size:', error);
          }
        }
      });
    });
  }

  // Restore size from URL parameter
  function restoreSize() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const savedSize = urlParams.get('size');

      if (savedSize) {
        // Escape special characters in selector
        const escapedSize = CSS.escape(savedSize);
        const sizeInput = document.querySelector(`input[name*="Size"][value="${escapedSize}"]`);
        if (sizeInput && !sizeInput.checked) {
          sizeInput.click();
        }
      }
    } catch (error) {
      // Silently fail - size restoration is a nice-to-have
      if (Shopify.designMode || window.DEBUG) {
        console.error('[Color Swatch] Error restoring size:', error);
      }
    }
  }

  // Initialize
  function init() {
    try {
      attachColorSwatchListeners();
      restoreSize();
    } catch (error) {
      // Log but don't break the page
      if (Shopify.designMode || window.DEBUG) {
        console.error('[Color Swatch] Initialization error:', error);
      }
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Shopify sections reload
  document.addEventListener('shopify:section:load', init);
})();
